import { dayjs } from "~/utils/dayjs";

export default function formatTimeSpan(start, end, type = "date") {
  const s = dayjs(start);
  const e = dayjs(end);
  let format = "DD/MM";

  if (type === "time") {
    format = "HH.mm";
  }

  if (type === "date" && (s.year() !== e.year() || s.year() !== dayjs().year() || e.year() !== dayjs().year())) {
    format = "DD/MM/YYYY";
  }

  return `${s.format(format)}–${e.format(format)}`;
}
